<div *ngIf="displayError" class="displayError">{{ displayError }}</div>

<ul>
    <li *ngFor="let folder of folders; let i = index" class="folder-item" (mouseenter)="onMoveMouseEnter(i)" (mouseleave)="onMoveMouseLeave(i)">
        <!-- <div class="icon-container">
            <img *ngIf="!isFolderItemHovered[i]" src="../../../../assets/organisation/icon-new-folder.svg" alt="Folder Icon" title="Folder Icon" class="icon topic_icon active" />
            <img
                *ngIf="isFolderItemHovered[i]"
                src="../../../../assets/organisation/icon-newfolder-hover-active.svg"
                alt="Folder Icon"
                title="Folder Icon"
                class="icon topic_icon inactive"
            />
        </div> -->
        <div
            class="icon-container"
            [ngStyle]="{ 'pointer-events': folder.isDisabled ? 'none' : 'auto', opacity: folder.isDisabled ? '0.5' : '1' }"
            [attr.aria-disabled]="folder.isDisabled ? 'true' : null"
        >
            <!-- Default Folder Icon -->
            <img
                *ngIf="!isFolderItemHovered[i] && !folder.isDisabled"
                src="../../../../assets/organisation/icon-new-folder.svg"
                alt="Folder Icon"
                title="Folder Icon"
                class="icon topic_icon active"
            />

            <img *ngIf="folder.isDisabled" src="../../../../assets/organisation/icon-new-folder.svg" alt="Folder Icon" title="Folder Icon" class="icon topic_icon active" />

            <!-- Hovered Folder Icon -->
            <img
                *ngIf="isFolderItemHovered[i] && !folder.isDisabled"
                src="../../../../assets/organisation/icon-newfolder-hover-active.svg"
                alt="Folder Icon"
                title="Folder Icon"
                class="icon topic_icon inactive"
            />
        </div>
        <div class="text-container">
            <!-- <a
                [class.disabled]="folder.isDisabled"
                href="javascript:void(0)"
                (click)="folder.isDisabled ? $event.preventDefault() : onFolderClick(folder)"
                class="folderName"
                [attr.id]="'go-move-folder-list-' + i"
                [attr.data-test]="'go-move-folder-list-' + i"
            > -->
            <a
                [class.disabled]="folder.isDisabled"
                href="javascript:void(0)"
                (click)="folder.isDisabled ? $event.preventDefault() : onFolderClick(folder)"
                class="folderName ellipsis-text"
                [attr.id]="'go-move-folder-list-' + i"
                [attr.data-test]="'go-move-folder-list-' + i"
                [attr.aria-disabled]="folder.isDisabled ? 'true' : null"
                [ngStyle]="{ 'pointer-events': folder.isDisabled ? 'none' : 'auto', color: folder.isDisabled ? 'gray' : 'inherit' }"
                title="{{ folder.folderName }}"
            >
                {{ folder.folderName }}
            </a>
            <!-- <a disabled="folder.isDisabled" href="javascript:void(0)" (click)="onFolderClick(folder)" class="folderName">{{ folder.folderName }}</a> -->
        </div>
    </li>
</ul>
